import { CardStatus } from '@seapoint/server/enums';
import { Badge } from '../../../design-system/badge/badge';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { getStatusLabel } from '../utils/get-status-label';

type CardStatusBadgeProps = {
  status: CardStatus;
  className?: string;
};

const getStatusBadgeVariant = (status: CardStatus) => {
  switch (status) {
    case CardStatus.ACTIVE:
      return 'positive' as const;
    case CardStatus.BLOCKED:
    case CardStatus.SUSPENDED:
      return 'warning' as const;
    case CardStatus.CANCELLED:
    case CardStatus.EXPIRED:
      return 'negative' as const;
    case CardStatus.CREATED:
      return 'neutral' as const;
    default:
      return exhaustiveCheck(status);
  }
};

export const CardStatusBadge = ({ status, className }: CardStatusBadgeProps) => {
  return (
    <Badge variant={getStatusBadgeVariant(status)} className={className}>
      {getStatusLabel(status)}
    </Badge>
  );
};
